module.exports = __webpack_public_path__ + "static/media/mailLetter.00dd7a74.png";